import type {Dispatch, ReactNode} from 'react';

import type {
  AfriexCountry,
  AfriexOTCTrade,
  AfriexRate,
  RatesMap,
} from '@/types';

export enum AppRatesType {
  GET_RATES = 'GET_RATES',
  GET_BUSINESS_RATES = 'GET_BUSINESS_RATES',
}

interface GetUserRatesAction {
  type: AppRatesType.GET_RATES;
  payload: Pick<
    AppRatesState,
    'rawAppRates' | 'appRates' | 'otcVolume' | 'loading'
  >;
}

interface GetBusinessRatesAction {
  type: AppRatesType.GET_BUSINESS_RATES;
  payload: Pick<
    AppRatesState,
    'businessRateList' | 'businessRates' | 'businessRateListLoading'
  >;
}

export type GetAppRatesAction = GetUserRatesAction | GetBusinessRatesAction;

export type AppRatesAction = GetAppRatesAction;

export interface AppRatesState {
  rawAppRates: AfriexRate[];
  businessRateList: AfriexRate[];
  businessRates: RatesMap;
  appRates: RatesMap;
  otcVolume: AfriexOTCTrade[];
  loading: boolean;
  businessRateListLoading: boolean;
}
export interface AppRatesContextType {
  state: AppRatesState;
  dispatch: Dispatch<AppRatesAction>;
}

export interface AppRatesProviderProps {
  children: ReactNode;
}

export interface ThemeContextProps {
  isDark: boolean;
  toggleDarkMode: () => void;
}

export enum CountryListActionType {
  FETCH_COUNTRIES = 'FETCH_COUNTRIES',
}

export interface CountryListState {
  loading: boolean;
  countryList: AfriexCountry[];
}

export interface CountryListAction {
  type: CountryListActionType;
  payload: Partial<CountryListState>;
}

export interface CountryListContextType {
  state: CountryListState;
  dispatch: React.Dispatch<CountryListAction>;
}
